// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KduRxx1lW4ExLH {
  display: flex;
  flex-direction: row;
  padding: var(--ds-space-0, 0) 6px;
  transition: padding 0.2s ease-in-out;
  list-style: none;
}
.KduRxx1lW4ExLH.kdUoe2vARtKb9C {
  /* stylelint-disable-next-line declaration-no-important */
  padding-bottom: 44px !important;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"lists": `KduRxx1lW4ExLH`,
	"islandNavPadding": `kdUoe2vARtKb9C`
};
export default ___CSS_LOADER_EXPORT___;
